import { EditableFieldType } from '../../ui/editable-field-node.model';
import { CaseFieldTypeResource } from '../../resource/case-field.resource';

export const EditableFieldTypeToCaseFieldTypeResourceMap = new Map<EditableFieldType, CaseFieldTypeResource>([
	['section', 0],
	['input', 1],
	['checkbox', 2],
]);
